import React from 'react';

const Home = (props) => (
  <svg
    viewBox="0 0 14.274 15.342"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>{`.homeicon{fill:transparent;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.5px;}`}</style>
    </defs>
    <g transform="translate(0.375 0.414)">
      <path
        className="homeicon"
        transform="translate(-75.186 -120.579)"
        d="M88.517,126.1l-5.964-5.367a.585.585,0,0,0-.767-.013L75.394,126.1a.583.583,0,0,0-.208.447v8.007a.583.583,0,0,0,.584.584h3.667a.583.583,0,0,0,.584-.584v-4.5a.584.584,0,0,1,.584-.584H83.29a.583.583,0,0,1,.584.584v4.5a.584.584,0,0,0,.584.584h3.668a.584.584,0,0,0,.584-.584V126.53A.583.583,0,0,0,88.517,126.1Z"
      />
    </g>
  </svg>
);

export default Home;
